// API utility functions for environment-aware URL handling

/**
 * Get the backend URL based on environment
 * - Development: http://localhost:5050
 * - Production: Same origin with /api prefix
 */
export const getBackendUrl = (): string => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:5050';
  }
  
  // In production, use the same origin with /api prefix
  return `${window.location.origin}/api`;
};

/**
 * Get the WebSocket URL based on environment
 * - Development: http://localhost:5050
 * - Production: Same origin with /socket.io/ path (nginx will proxy to backend)
 */
export const getWebSocketUrl = (): string => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:5050';
  }
  
  // In production, use the same origin with /socket.io/ path
  // nginx will proxy /socket.io/ to backend
  return window.location.origin;
};

/**
 * Get the API base URL for HTTP requests
 * - Development: http://localhost:5050
 * - Production: Same origin with /api prefix
 */
export const getApiBaseUrl = (): string => {
  return getBackendUrl();
};

/**
 * Check if we're in development mode
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * Check if we're in production mode
 */
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};
